/**
 * The router adapter the design system's link-taking components need.
 *
 * `Tabs` and `Breadcrumb` accept a `LinkComponent` rather than importing the
 * router, because the design system must not know how navigation works — the
 * same rule `UnsavedChangesGuard` follows, and the reason it lives at the app
 * layer too. This is the adapter that plugs one into the other.
 *
 * Extracted 2026-08-26 from NINE identical local copies, in two slightly
 * different shapes, none of which was importable. Nine copies of a five-line
 * component is not nine bugs, but it is nine places for the tenth to differ —
 * and the two shapes had already diverged: one typed its props by hand and
 * silently accepted no other anchor attribute, so a `title` or a `target` on
 * one screen's tab would have been dropped without a type error.
 */

import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router';

export function RouterAnchor({
  href,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { readonly href: string }): ReactNode {
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}
